import {SEARCH_TYPE_ORDER} from '@embertracking/common/data/search/types.mjs';

// How result GROUPS are ordered against each other. Pure, so the rule is
// testable without React or a network round trip.
//
// Ordering by best hit rather than by a fixed type catalog is what makes
// searching "matrix" lead with the Qualification Matrix page instead of burying
// it under whichever type the catalog happens to list first.

// Weighted by what a type usually MEANS to someone typing. Raw relevance alone
// gets two cases wrong in ways that matter:
//
//   settings — the Settings rail has a section literally titled
//     "Qualifications", so on an exact-title match it outranks the Qualification
//     Matrix page, even though someone typing "qualifications" almost always
//     wants the matrix and not the panel configuring how it renders. Settings is
//     a configuration surface you reach deliberately; pages and records are the
//     app's primary nouns.
//
//   members — a PERSON is the most-searched thing in this app, and a person's
//     name is attached to a lot of records that are not them. Searching "brooks"
//     surfaced a bunker set assigned to Daniel Brooks above Daniel Brooks, which
//     is never what was meant. (The scoring half of that bug — the holder's name
//     counted twice on the gear row — is fixed in the api's gearEntry; this is
//     the intent half, and it holds even when a record legitimately mentions
//     someone several times.)
//
// Both are deliberately a nudge and not an override: a query that only matches
// Settings still leads with Settings, because it is then the only group there is.
export const TYPE_PRIORITY = {members: 1.4, settings: 0.4};

export const groupRank = group => {
    const best = (group.items || []).reduce((top, item) => Math.max(top, item.score || 0), 0);
    return best * (TYPE_PRIORITY[group.type] ?? 1);
};

/**
 * Sort groups best-first. The type catalog is only the tiebreak, so equally-good
 * groups keep a stable, learnable order rather than shuffling between keystrokes.
 */
export const orderGroups = groups => [...groups].sort(
    // Help is a fallback even when an article's title is an exact match.
    (a, b) => (Number(a.type === 'help') - Number(b.type === 'help'))
        || (groupRank(b) - groupRank(a))
        || (SEARCH_TYPE_ORDER.indexOf(a.type) - SEARCH_TYPE_ORDER.indexOf(b.type))
);
